import Image from "next/image";
import CTALink from "@/components/CTA/ctaLink";
import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";
import boldTextWithAsterisk from "@/utils/functions/boldTextWithAsterisk";

export default function PromoBannerBento({
  className,
  cta,
  ctaElement,
  description,
  discount,
  discountCode,
  endDatePrefix = "Offer ends",
  endDate,
  image,
  learnMoreLink,
  title,
  useDefaultDiscountText = true,
  tooltip,
}: BasePromoBannerProps) {
  return (
    <div
      className={`flex flex-col gap-4 mx-auto max-w-[620px] ${className || ""}`}
    >
      <div className="flex flex-col items-stretch sm:flex-row gap-4">
        <div
          className={`bg-secondary rounded-xl p-4 sm:p-10 ${image?.url ? "basis-1/2" : "w-full"}`}
        >
          <h2 className="text-2xl sm:text-3xl text-secondary-foreground italic m-0">
            {title}
          </h2>
        </div>
        {image?.url && (
          <div className="relative rounded-xl basis-1/2">
            {image.height && image.width && (
              <Image
                src={image.url}
                alt={image.altText || ""}
                height={image.height}
                width={image.width}
                className="sm:hidden rounded-xl"
              />
            )}
            <Image
              src={image.url}
              alt={image.altText || ""}
              className="hidden object-cover sm:block rounded-xl"
              fill
            />
          </div>
        )}
      </div>
      <div className="bg-primary rounded-xl p-4 sm:p-10">
        <p className="elm-p5 text-primary-foreground mb-4">
          {typeof description === "string"
            ? boldTextWithAsterisk(description)
            : description}{" "}
          {useDefaultDiscountText && !!discount && !!discountCode && (
            <span>
              Get <strong>up to {discount} off</strong> on select courses with
              code <strong>{discountCode}</strong>.
            </span>
          )}
        </p>
        {cta && !ctaElement && (
          <CTALink
            type="brand"
            size="xl"
            className="mb-4 w-full sm:w-auto"
            label={cta.label}
            url={cta.url}
            location={cta.location}
            html_id={cta.html_id}
          />
        )}
        {ctaElement}
        <div className="flex gap-1 items-center">
          <p className="elm-p3 text-primary-foreground elm-p3 mb-0">
            {endDatePrefix} {endDate}.
          </p>
          <PromoBannerTooltip
            discountCode={discountCode}
            endDate={endDate}
            htmlContent={tooltip?.infoText ?? ""}
            learnMoreLink={learnMoreLink}
          />
        </div>
      </div>
    </div>
  );
}
